/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EC2Instance } from './eC2Instance';
import { RDSInstances } from './rDSInstances';


export interface IRRStatusInfo { 
    ec2_instances: Array<EC2Instance>;
    rds_instances: Array<RDSInstances>;
}

